import * as yup from "yup";
import { getTrimmedStringValidationRequired } from "@/shared/yup";

export const getAddTagModalSchema = () =>
  yup.object({
    tag: getTrimmedStringValidationRequired(),
  });

export type AddTagModalFormValues = yup.InferType<ReturnType<typeof getAddTagModalSchema>>;
